// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7655) return "static/chunks/7655-0562b8641b7206f0.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5647 ? "ca377847" : chunkId) + "." + {"1720":"17f4dd8e802692f5","5330":"8e7f45c3e66255b2","5647":"31ecb44ea625cfec"}[chunkId] + ".js";
};